import { Typography } from '@material-ui/core';
import { TypeText } from '@material-ui/core/styles/createPalette';
import { TypographyProps } from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, { FC, memo } from 'react';

import useStyles from './styles';

export interface CountBaseProps {
  number: number;
  textColor: keyof TypeText;
}

export type CountProps = CountBaseProps & TypographyProps;

export const Count: FC<CountProps> = ({ className, textColor = 'disabled', number, variant = 'h5' }) => {
  const classes = useStyles({ textColor });
  return (
    <Typography className={classNames(classes.number, className)} variant={variant}>
      {number}
    </Typography>
  );
};

export default memo(Count);
